$(document).ready(function() {
    startNiceSelect();
});

function startNiceSelect() {
    $(".start-nice-select").niceSelect();
}